const REQUEST_ONLY_GROUP_KEY = "requestonly";
const GROUP_OWNERS_GROUP_KEY = "groupowners";

const normalizeGroupKey = (group: string): string =>
  group.trim().toLowerCase().replace(/[^a-z0-9]/g, "");

export const isRequestOnlyGroup = (group: string): boolean =>
  normalizeGroupKey(group) === REQUEST_ONLY_GROUP_KEY;

export const userIsInRequestOnlyGroup = (groups: string[]): boolean =>
  groups.some(isRequestOnlyGroup);

export const isGroupOwnersGroup = (group: string): boolean =>
  normalizeGroupKey(group) === GROUP_OWNERS_GROUP_KEY;

export const userIsGroupOwner = (groups: string[]): boolean =>
  groups.some(isGroupOwnersGroup);
